import { styled } from '@mui/material';
import MuiDialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle';
import Stack from '../Stack';
import Box from '../Box';
import { AutoAwesomeMosaic } from '@mui/icons-material';

export interface IDialogTitleProps extends DialogTitleProps {
  icons?: React.ReactNode;
};

const CustomDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  whiteSpace: "normal",
  lineHeight: "16px",
}));

const DialogTitle = (props: IDialogTitleProps): JSX.Element => {
  return (
    <CustomDialogTitle
      {...props}
      sx={{ ...props.sx, m: 0, p: 1 }}
      id={props.id ? props.id : "draggable-dialog-title"}
      style={{ cursor: "move" }}
    >
      <Stack direction={"row"} alignItems={"center"}>
        <Box pr={1}>
          {props.icons || <AutoAwesomeMosaic color='primary' />}
        </Box>
        {props.children}
      </Stack>
    </CustomDialogTitle>
  );
};

export default DialogTitle;
